import { API_BASE_URL, parseJsonResponse } from './apiConfig'

async function fetchWithTimeout(resource, options = {}, timeout = 10000) {
  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeout)
  try {
    const response = await fetch(resource, {
      ...options,
      signal: controller.signal,
    })
    clearTimeout(id)
    return response
  } catch (error) {
    clearTimeout(id)
    throw error
  }
}

export async function fetchEmployeeNotifications(employeeId) {
  console.log('Fetching notifications for employee:', employeeId)
  const response = await fetchWithTimeout(`${API_BASE_URL}/notifications/employee/${employeeId}`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }, 30000)

  console.log('Notifications fetch response status:', response.status)

  if (!response.ok) {
    const errorText = await response.text()
    console.error('Notifications fetch error response:', errorText)
    throw new Error(`Failed to fetch notifications: ${response.status} - ${errorText}`)
  }

  const data = await parseJsonResponse(response, 'Failed to fetch notifications')
  const notifications = Array.isArray(data) ? data : data?.notifications || []
  console.log('Notifications fetched successfully, count:', notifications.length)
  return notifications
}

export async function fetchUnreadCount(employeeId) {
  console.log('Fetching unread count for employee:', employeeId)
  const response = await fetchWithTimeout(`${API_BASE_URL}/notifications/employee/${employeeId}/unread-count`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }, 30000)

  console.log('Unread count fetch response status:', response.status)

  if (!response.ok) {
    const errorText = await response.text()
    console.error('Unread count fetch error response:', errorText)
    throw new Error(`Failed to fetch unread count: ${response.status} - ${errorText}`)
  }

  const data = await parseJsonResponse(response, 'Failed to fetch unread count')
  console.log('Unread count fetched:', data.count)
  return data
}

export async function markNotificationAsRead(notificationId) {
  const response = await fetchWithTimeout(`${API_BASE_URL}/notifications/${notificationId}/read`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to mark notification as read')
  }

  return parseJsonResponse(response, 'Failed to mark notification as read')
}

export async function markAllAsRead(employeeId) {
  const response = await fetchWithTimeout(`${API_BASE_URL}/notifications/employee/${employeeId}/read-all`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
  })

  if (!response.ok) {
    throw new Error('Failed to mark all as read')
  }

  return parseJsonResponse(response, 'Failed to mark all as read')
}
